import { Injectable, signal } from '@angular/core';
import type { AuthenticationMethod, AuthProvider } from '@api';

@Injectable({ providedIn: 'root' })
export class AuthenticationState {
  private readonly _providers = signal<AuthProvider[] | null>(null);
  private readonly _authenticationMethod = signal<AuthenticationMethod | null>(null);

  readonly providers = this._providers.asReadonly();
  readonly authenticationMethod = this._authenticationMethod.asReadonly();

  setProviders(providers: AuthProvider[]): void {
    this._providers.set(providers);
  }

  setAuthenticationMethod(method: AuthenticationMethod | null): void {
    this._authenticationMethod.set(method);
  }

  resetAuthenticationMethod(): void {
    this._authenticationMethod.set(null);
  }
}
